import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import AssuranceService from '../services/AssuranceService';
import { itemPerPage, pageMaxSize } from '../baseUrls/consts';
import { Dropdown } from 'primereact/dropdown';
import TypeAssuranceService from '../services/TypeAssuranceService';
import VehiculeService from '../services/VehiculeService';
import TiersService from '../services/TiersService';
import { Calendar } from 'primereact/calendar';

const Assurance = () => {
    const [yesNo, setYesNo] = useState({});
    const [form, setForm] = useState({});
    
    return (
        <div>
            <div className="card">
                <Table {...{setForm, setYesNo}} />
                <Form {...{form, setYesNo}} />
                <Confirmation {...yesNo} />
            </div>
            
        </div>
    );
}

const Table = (props) => {
    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(true);
    const {setForm, setYesNo} = props;

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        loadItems();
    }, []);

    const loadItems = () => {
        AssuranceService.get((data, status) => {
                setLoading(false);
                if(status) setItems(data);   
            },
            {size: itemPerPage}
        );
    }

    const openNew = () => {
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
            data: null,
            setData: (data)=> setForm((prev)=>({...prev, data})),
            callback: ()=> {
                setLoading(true);
                loadItems();
            }
        });
    }

    const editItem = (item) => {
        setForm({
            visible: true,
            hide: ()=> setForm((prev)=>({...prev, visible: false})),
            data: item,
            setData: (data)=> setForm((prev)=>({...prev, data})),
            callback: ()=> {
                setLoading(true);
                loadItems();
            }
        })
    }

    const deleteItem = (item) => {
        setYesNo({   
            visible: true,
            message : "Confirmez-vous la suppression ?",
            hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
            callback : ()=> {
                setLoading(true);
                AssuranceService.delete(item.id, (data, status)=>{
                    setLoading(false);
                    loadItems();
                });
            },
        });
    }

    //const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    //console.log(timeZone);

    
    return (
        <>
            <h5>Liste des assurances</h5>
            <Toolbar className="mb-4" 
                left={
                    <React.Fragment>
                        <div className="my-2">
                            <Button label="Nouveau" icon="pi pi-plus" className="p-button-success mr-2" 
                                onClick={openNew}/>
                            <Button label="Actualiser" icon="pi pi-refresh" className="p-button-primry mr-2" 
                                onClick={()=>{setLoading(true); loadItems()}} />
                        </div>
                    </React.Fragment>
                } 
                right={
                    <React.Fragment>
                        <span className="block mt-2 md:mt-0 p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText type="search" placeholder="Recherche..." onInput={(e) => setGlobalFilter(e.target.value)} />
                        </span>
                    </React.Fragment>
                } />
            <DataTable dataKey="id" value={items} 
                paginator rows={10} /*first={first}  
                totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange}  */
                loading={loading} globalFilter={globalFilter} 
                responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

                <Column field="id" header="Identifiant" hidden sortable />
                <Column field="vehicule.immatriculation" header="Véhicule" sortable />
                <Column field="dateDebut" header="Date Début assurance" sortable 
                    body={(item)=> new Date(item.dateDebut).toLocaleDateString()}/>
                <Column field="dateFin" header="Date fin assurance" sortable style={{fontWeight: 'bold'}} 
                    body={(item)=> new Date(item.dateFin).toLocaleDateString()}/>
                <Column field="montant" header="Montant" sortable body={item => item.montant?.toLocaleString()} />
                <Column field="numeroPolice" header="Numéro police" sortable />
                <Column field="typeAssurance.libelleTypeAssurance" header="Libellé type assurance" sortable />
                <Column field="tiers.nom" header="Nom tiers" sortable />
                <Column field="referenceCava" header="Reference CAVA" sortable />
                <Column field="numeroCava" header="Numéro CVA" sortable />
                <Column body={ (selectedItem)=>
                    <div className="flex justify-content-end">
                        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2" onClick={() => editItem(selectedItem)}/>
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-warning mr-2" onClick={()=> deleteItem(selectedItem)}/>
                    </div>
                } />
            </DataTable>
        </>
    );
}

const Form = (props) => {
    const {visible, hide, data, setData, callback } = props.form;
    const {setYesNo} = props;
    const[loading, setLoading] = useState(false);

    const [typeAssurance, setTypeAssurance] = useState([]);
    const [vehicules, setVehicules] = useState([]);
    const [tierses, setTierses] = useState([]);

    useEffect(()=> {
        if(!visible) return;
        TypeAssuranceService.get((data)=> data && setTypeAssurance(data), {size: pageMaxSize})
    }, [visible]);

    useEffect(()=> {
        if(!visible) return;
        VehiculeService.get((data)=> data && setVehicules(data), {size: pageMaxSize})
    }, [visible]);

    useEffect(()=> {
        if(!visible) return;
        TiersService.get((data)=> data && setTierses(data), {size: pageMaxSize})
    }, [visible]);
    
    const bind = (e) => {
        if(e.target.value !== undefined) {
            let value = e.target.value;
            setData({...data, [e.target.id]: value});
            console.log(data);
        }
        else if(e.checked !== undefined) {
            setData({...data, [e.target.id]: e.target.checked});
        }else{
            alert("Binding fails.")
        }
    }
    
    const submit = () => {
        setYesNo(
            {   
                visible: true,
                message : data.id ? "Confirmez-vous la modification ?" : "Confirmez-vous l'ajout ?",
                hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
                callback : ()=> {
                    setLoading(true);
                    let onResponse = (data, status)=> {
                            setLoading(false);
                            if(!status) return;
                            hide();
                            callback();
                    }
                    if(data.id) {
                        AssuranceService.update(data, onResponse)
                        console.log(data);
                    } else{
                        AssuranceService.add(data, onResponse);
                        console.log(data);
                    }
                },
            }
        )
    
    }

    return(
        <Dialog visible={visible} style={{ width: '800px' }} header="Détails d'une assurance" modal className="p-fluid" 
            footer={
                <>
                    <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={hide}  />
                    <Button label="Valider" icon="pi pi-check" className="p-button-text" onClick={submit} loading={loading} />
                </>
            } 
            onHide={hide}
            >  
                <div className="field" hidden>
                    <label htmlFor="id">Identifiant</label>
                    <InputText id="id" value={data && data.id} onChange={bind} />
                </div>
                <div className="field">
                    <label htmlFor="dateDebut">Date début</label>
                    <InputText type="date" id="dateDebut" value={data && data.dateDebut} onChange={bind} />
                </div>
                <div className="field">
                    <label htmlFor="dateFin">Date fin</label>
                    <InputText type="date" id="dateFin" value={data && data.dateFin} onChange={bind} />
                </div>
                <div className="field">
                    <label htmlFor="montant">Montant</label>
                    <InputNumber id="montant" value={data && data.montant} 
                        onValueChange={bind} required keyfilter="num" />
                </div>
                <div className="field">
                    <label htmlFor="numeroPolice">Numéro police</label>
                    <InputText id="numeroPolice" value={data && data.numeroPolice} onChange={bind} 
                        placeholder="" />
                </div>
                <div className="field">
                    <label htmlFor="typeAssurance">Type Assurance</label>
                    <Dropdown id="typeAssurance" options={typeAssurance} value={data?.typeAssurance} onChange={bind}
                        optionLabel="libelleTypeAssurance" /*optionValue="id"*/  
                        placeholder="Aucune sélection"/>
                </div>
                <div className="field">
                    <label htmlFor="vehicule">Matériel roulant</label>
                    <Dropdown id="vehicule" options={vehicules} value={data?.vehicule} onChange={bind}
                        optionLabel="immatriculation" /*optionValue="id"*/  
                        placeholder="Aucune sélection"/>
                </div>
                <div className="field">
                    <label htmlFor="tiers">Tiers</label>
                    <Dropdown id="tiers" options={tierses} value={data?.tiers} onChange={bind}
                        optionLabel="nom" /*optionValue="id"*/  
                        placeholder="Aucune sélection"/>
                </div>
                <div className="field">
                    <label htmlFor="referenceCava">Référence CAVA</label>
                    <InputText id="referenceCava" value={data && data.referenceCava}
                         onChange={bind} required placeholder=" " />
                </div>
                <div className="field">
                    <label htmlFor="numeroCava">Numéro CVA</label>
                    <InputText id="numeroCava" value={data && data.numeroCava} onChange={bind} 
                        placeholder="" />
                </div>
            </Dialog>
    )
}

const Confirmation = (props) => {
    const {visible, hide, message, callback } = props;
    
    return (
        <Dialog modal visible={visible} onHide={hide} 
            header="Confirmation" style={{ width: '350px' }}
            footer={
                <>
                    <Button type="button" label="Non" icon="pi pi-times" 
                        onClick={hide} 
                        className="p-button-text" />
                    <Button type="button" label="Oui" icon="pi pi-check" 
                        onClick={() => { hide(); callback() }} 
                        className="p-button-text" autoFocus />
                </>
            }>
            <div className="flex align-items-center justify-content-center">
                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                <span>{message != null ? message : "Voulez-vous continuer ?"}</span>
            </div>
        </Dialog>
    )
}

export default Assurance;